import React, { FC } from 'react';

import { useApiObject } from 'src/explore/hooks/useApiObject';
import { IMerchant, INavItem } from 'src/prize/types/shoppe';

import Angelinas from './organisms/Angelinas';
import { ByrdCookieCompany } from './organisms/ByrdCookieCompany';
import CameronsSeafood from './organisms/CameronsSeafood';
import Default from './organisms/Default';
import GetMaineLobster from './organisms/GetMaineLobster';
import LastCrumb from './organisms/LastCrumb';
import Miette from './organisms/Miette';
import Raos from './organisms/Raos';
import SouthsideMarket from './organisms/SouthsideMarket';

interface MenuProps {
  merchant: IMerchant;
}

const Menu: FC<MenuProps> = ({ merchant }) => {
  const { data } = useApiObject<{ data?: INavItem }>( `nav_menu`, {
    apiPathOverride: '/api/v4/',
    camelCaseKeys: true,
  });

  switch ( merchant.prizeFilePath ) {
    case 'angelinas_of_maryland':
      return <Angelinas links={data?.data} merchant={merchant} />;
    case 'byrd_cookie_company':
      return <ByrdCookieCompany links={data?.data} merchant={merchant} />;
    case 'camerons_seafood':
      return <CameronsSeafood links={data?.data} merchant={merchant} />;
    case 'get_maine_lobster':
      return <GetMaineLobster links={data?.data} merchant={merchant} />;
    case 'last_crumb':
      return <LastCrumb links={data?.data} merchant={merchant} />;
    case 'miette':
      return <Miette links={data?.data} merchant={merchant} />;
    case 'raos':
      return <Raos links={data?.data} merchant={merchant} />;
    case 'southside_market_and_barbeque':
      return <SouthsideMarket links={data?.data} merchant={merchant} />;
    default:
      return <Default links={data?.data} merchant={merchant} />;
  }
};

export default Menu;
